<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id" :initialAttr="initialAttr">
        <!-- IE 2026 09 07 / ODOO-337259: подсказка кнопки «ленивая» — контент при показе (Alt / Show tooltips) -->
        <!-- IE 2026 11 02 / ODOO-350449 (заказ Игоря: p217 кнопка Σ — річні підсумки за опцією, типово вимкнено): aria-pressed у кнопки-переключателя Σ -->
        <!-- demo-webscm 2026 11 02 / ODOO-350612: data-help = ключ объяснения кнопки (attr.uiHelp / uiHelpFallback) — цель kind 'ui' тура навигатора (guideTarget_uiEl) находит кнопку команды таблицы -->
        <Button
            :id="attr.html_id"
            :class="buttonClass"
            :disabled="attr.disabled"
            :aria-pressed="attr.front_only && attr.name === 'year-totals' ? String(!!attr.active) : undefined"
            :data-help="attr.uiHelp || attr.uiHelpFallback || undefined"
            v-wjTooltipFn="tooltip"
            @click="onClick($event)"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave"
            v-if="isVisible"
        >
            <div class="badge" v-if="attr.countItems && !attr['hide-countItems']">{{ store?.formatCount(attr.countItems) }}</div>
            <span v-html="attr.titleCommand || ''"></span>
        </Button>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { uiHelp_rowsHtml, uiHelp_enabled, uiHelp_entry, UI_HELP_ROWS } from '@/utils/uiHelp'   // U6 (заказ Игоря: объяснение элементов по Alt): необязательное поле определения кнопки uiHelp
import { tipEn_name, tipEn_html } from '@/utils/tipEnName'   // IE 2026 09 27 / ODOO-341407 (заказ Игоря 27.09: английское имя в подсказке)
import { editCommit_pending } from '@/utils/editCommit'   // IE 2026 10 14 / ODOO-345813 (заказ Игоря: окна остановок регламента): открытый редактор ячейки закрывается ДО действия кнопки (Save, Preview …)

export default {
    emits: ['mouseenter', 'mouseleave'],
    props: {
        attr_id: String,
        widget_id: [String, Number],
        initialAttr: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        attr: {},
        WIDGET: {},
        isVisible: false,
    }),
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()

        // if (this.attr.shortkey) {
        // //    this.$shortkey(this.attr.hotkey, 'onClick');
        // }
        this.store.prepare_actionMenu(this.attr)
    },
    mounted() {
        this.updateVisibility()
        this.addWatchers()
        // IE 2026 09 11 / ODOO-… (замечание Игоря: после выбора другой настройки в Settings tree пропадала кнопка «непустые»):
        // командная панель обновляется «на месте» (updateCommandPanelInPlace) по ПОЗИЦИОННЫМ id — при смене настройки
        // (reload) состав панели меняется, и объект кнопки получает ДРУГОЕ определение (кнопка «непустые» встала на место
        // скрытой isMapped-widget). :key и initialAttr те же — компонент переиспользуется, а isVisible считался один раз
        // при монтировании (вотчеры — только у кнопок с v-if): кнопка оставалась скрытой. Следим за полями, от которых
        // зависят видимость и вид, и пересчитываем; появился v-if — добавляем его вотчеры
        this.$watch(
            () => [this.attr?.hide, this.attr?.visible, this.attr?.name, this.attr?.command, this.attr?.method, this.attr?.['v-if'],
                this.attr?.viewAccess, this.attr?.title, this.attr?.showCommandTitle, this.attr?.cssClass],
            () => {
                if (this.attr?.['v-if'] && !this._vifWatchers) this.addWatchers()
                if (this.attr) this.store.prepare_actionMenu(this.attr)
                this.updateVisibility()
            })
    },
    beforeUnmount() {
        this.store.attr_deregister(this)
    },
    methods: {
        content_Changed() {
            if (this.initialAttr) {
                // attr передан объектом — id в поиске не участвует (опционален);
                // регистрацию в реестре по id сохраняем (set-binding, tooltipChange)
                this.attr = this.initialAttr
                if (this.attr_id != null) {
                    // виджета может не быть в сторе (стол пересоздан при смене
                    // процессной модели) — перерезолвим, иначе TypeError рвёт рендер
                    if (!this.WIDGET) this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
                    if (!this.WIDGET) return
                    this.WIDGET.attrs_vueObj[this.attr_id] = this
                }
            } else {
                this.store.widget_attr_set(this)
            }
        },
        onClick(event) {
            if (this.attr.inactive) return   // IE 2026 10 13 / ODOO-5800: enabled_when — в выделении нет подходящих строк (utils/buttonsEnabledWhen), действие не отправляется
            if (this.WIDGET.widget === 'widget_GLOBAL_SEARCH') {
                this.store.globalSearch.hide()
                this.attr.params = {
                    CHIPS: this.store.globalSearch.CHIPS,
                }
            }

            let vueObj = this.WIDGET.vueObj || this.WIDGET.vueObj_cmdHost   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114070: «Історія змін» v2, итерация 2 Igor): синтетический виджет без Widget.vue (графики истории, utils/pmHistoryChart.pmHistory_chartHost) — хозяин команд
            if (!vueObj) return   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114070: «Історія змін» v2, итерация 2 Igor): нет хозяина — без TypeError
            editCommit_pending(this.WIDGET, this.store, 'button:' + (this.attr.method || this.attr.command || ''))   // IE 2026 10 14 / ODOO-345813 (заказ Игоря: окна остановок регламента): значение открытого редактора ячейки — в запись до отправки (та же гонка с таймером lostFocus wijmo, что у ленивой вкладки; fe.ux.commitEditsBeforeAction)
            vueObj.store.executeStoreMethod(vueObj, this.attr, null, null, event)
        },
        tooltip() {
            const attrButton = this.attr
            let params = {}
            
            // IE 2026 09 23 / ODOO-341407: i18n — подписи-ключи подсказки
            params[this.t('Action')] = attrButton.title
            // IE 2026 09 27 / ODOO-341407 (заказ Игоря 27.09: «в tooltip если язык не eng то дополнительно показывай название на англ»): английское имя кнопки рядом с переведённым —
            // бэкап подписи бэка title_en, у кнопки фронта — ключ словаря t(); у кнопки без подписи названием служит шапка (tooltip) — бэкап tooltip_en (utils/tipEnName.js)
            if (attrButton.title) params[this.t('Action')] += tipEn_html(tipEn_name(attrButton.title, { raw: attrButton, store: this.store, ui: true }))
            const tipEnHead = (!attrButton.title && attrButton.tooltip) ? tipEn_html(tipEn_name(attrButton.tooltip, { en: attrButton.tooltip_en, store: this.store, ui: true })) : ''
            if (attrButton.hotkey) {
                params[this.t('HotKey')] = attrButton.hotkey
            }

            params[this.t('Action ID')] = attrButton.action_name
            params[this.t('Command')] = attrButton.command
            params[this.t('Method')] = attrButton.method
            params[this.t('Target field')] = attrButton.binding
            params[this.t('Exclude')] = (attrButton.record_sendToBackend_exclude || []).join(', ')

            const ewHead = attrButton.inactive && attrButton.inactive_reason ? '<b>' + this.t(attrButton.inactive_reason) + '</b><br>' : ''   // IE 2026 10 13 / ODOO-5800: enabled_when — причина неактивности первой строкой
            let html = this.store.tooltip_html(params, ewHead + (attrButton.tooltip||'') + tipEnHead)   // IE 2026 10 13 / ODOO-5800: + ewHead   // IE 2026 09 27 / ODOO-341407: + английское имя шапки
            // U6: определение кнопки может нести uiHelp (строка-ключ; ставится владельцем — как правило, для целого
            // ряда быстрых настроек, один ключ на все его кнопки) и uiHelpState (функция () => состояние) - строки
            // объяснения дописываются в конец существующей подсказки (способ 2), кнопки/поля выше не меняются
            // (выключатель fe.ux.uiHelp = false — прежняя подсказка без строк; ошибка функции состояния — строки без Now)
            // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: ключ — attr.uiHelp (кнопки формы «⋯» / commandPanel_Scale в Widget.vue data(), «Close child widgets» в mainStore.js,
            // быстрые настройки U6) либо для шести ИМЕННЫХ бэкенд-кнопок шапки — матч uiHelp_buttonKey (ниже); состояние — uiHelpState(WIDGET, attr) литерала, у бэкенд-кнопок —
            // attr.active → on / off. Без общего fallback-ключа: AttrButton используется ВЕЗДЕ (панели грида, диалоги) — широкий fallback подписывал бы чужие кнопки как «команда шапки виджета»
            if (uiHelp_enabled()) {
                let key3 = attrButton.uiHelp || '', st6
                if (key3) {
                    st6 = attrButton.uiHelpState
                    try { if (typeof st6 === 'function') st6 = st6(this.WIDGET, attrButton) } catch (e) { st6 = null }
                } else {
                    key3 = this.uiHelp_buttonKey(attrButton)
                    if (key3) st6 = attrButton.active ? 'on' : 'off'
                    // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U5 (накат 28.09): запасной ключ кнопки серверной командной панели таблицы (AttrGrid.set_commandPanel: attr.uiHelpFallback =
                    // 'grid.commandPanel.backend') — только когда нет ни своего attr.uiHelp, ни ключа матчера выше
                    else if (attrButton.uiHelpFallback) key3 = String(attrButton.uiHelpFallback)
                }
                // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3 (накат 26.09, дубль HotKey): у кнопки своя техстрока HotKey (attr.hotkey) — совпадающая с ней строка HotKey
                // объяснения не выводится; более подробная («Alt W or Esc; Alt+Esc — reopen», «Alt 1…8 — size presets») остаётся
                const vars3 = (attrButton.uiHelpVars && typeof attrButton.uiHelpVars === 'object') ? attrButton.uiHelpVars : {}   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): переменные объяснения ({segment}, {row} …) от владельца кнопки
                if (key3) {
                    let fields3
                    if (attrButton.hotkey) {
                        const norm3 = (s) => String(s || '').replace(/\s+/g, ' ').trim().toLowerCase()
                        const e3 = uiHelp_entry(key3, { state: st6, vars: vars3 })   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): + vars
                        if (e3 && norm3(e3.hotkey) === norm3(attrButton.hotkey)) fields3 = UI_HELP_ROWS.filter(f => f !== 'hotkey')
                    }
                    html += uiHelp_rowsHtml(key3, { state: st6, vars: vars3 }, fields3)   // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): + vars
                }
            }
            return html
        },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: кнопки шапки, которые приходят С БЭКА без своего attr.uiHelp — один из шести устойчивых, языконезависимых
        // признаков (name / command+method / widget) — сверено по коду be_igor common_modules/widgets.py; нет матча — '' (как было: только Action/HotKey/…)
        uiHelp_buttonKey(attrButton) {
            if (attrButton.name === 'button-Save') return 'widget.header.btn.save'
            if (attrButton.command === 'executeWidgetMethod' && attrButton.method === 'select') return 'widget.header.btn.update'
            if (attrButton.name === 'non-empty-widget') return 'widget.header.btn.hideEmpty'
            if (attrButton.name === 'isMapped-widget') return 'widget.header.btn.mapping'
            if (attrButton.widget === 'widget-docs') return 'widget.header.btn.docs'
            if (attrButton.view && attrButton.front_only) return 'widget.header.btn.cellView'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1): кнопка вида ячеек (view + front_only) — своё объяснение
            if (attrButton.command === 'executeWidgetMethod' && attrButton.method === 'toggle_option_group') return 'widget.header.btn.optionGroup'
            return ''
        },
        onMouseEnter(event) {
            this.$emit('mouseenter', event, this);
        },
        onMouseLeave(event) {
            this.$emit('mouseleave', event, this);
        },
        updateVisibility() {
            const attrButton = this.attr
            this.isVisible =
                attrButton.visible !== false &&
                attrButton.hide !== true &&
                this.store.checkAccess(attrButton, this.WIDGET) &&   // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: ежедневный архив ПМ): + WIDGET — архив прячет запись только у данных модели (ревью #110599)
                this.store?.eval_value(this.WIDGET, attrButton['v-if'], {}, attrButton)
        },
        addWatchers() {
            // this.WIDGET может быть null: findWidget штатно отдаёт {WIDGET:null}
            // для виджета, которого в сторе уже (или ещё) нет — например при
            // переоткрытии. Без '?.' геттер вотчера бросал прямо в mounted(),
            // и виджет оставался пустым, а в консоль сыпалось
            // «Cannot read properties of null (reading 'record')»
            if (this.attr['v-if']) {
                this._vifWatchers = true   // IE 2026 09 11 / ODOO-…: вотчеры v-if уже стоят (см. mounted)
                // () => this.attr, а не замыкание на объект: при смене initialAttr
                // deep-watch должен следить за новым объектом
                this.$watch( () => this.attr, (newVal, oldVal) => {
                    this.updateVisibility()
                }, { deep: true } )

                this.$watch( () => this.WIDGET?.record?.id, (newVal, oldVal) => {
                    this.updateVisibility()
                })

                this.$watch( () => this.WIDGET?.record?.doc?.params, (newVal, oldVal) => {
                    this.updateVisibility()
                }, { deep: true } )

                this.$watch( () => this.WIDGET?.record?.doc?.viewParams, (newVal, oldVal) => {
                    this.updateVisibility()
                }, { deep: true } )

                this.$watch( () => this.WIDGET?.record?._meta, (newVal, oldVal) => {
                    this.updateVisibility()
                }, { deep: true } )

                this.$watch( () => this.WIDGET?._view, (newVal, oldVal) => {
                    this.updateVisibility()
                }, { deep: true } )

                // IE 2026 09 28 / ODOO-342342 (ревью З1): v-if по служебной части записи (_doc.<ключ>, напр. кнопки ★ / «Mark as done» карточки
                // кейса — get_value('_doc.personal.fav')) пересчитывается при смене ЭТОГО ключа. Весь _doc не смотрим (там данные виджета) —
                // только ключи, названные в v-if; _doc.data — без deep
                const docKeys = [...new Set([...String(this.attr['v-if']).matchAll(/_doc\.([A-Za-z_][A-Za-z0-9_]*)/g)].map(m => m[1]))]
                for (const k of docKeys) {
                    this.$watch( () => this.WIDGET?.record?._doc?.[k], () => {
                        this.updateVisibility()
                    }, { deep: k !== 'data' } )
                }
            }
    },
    },
    computed: {
        buttonClass() {
            return [
                'commandPanel-buttons p-button-sm p-button-no-border p-2 ' + (this.attr.cssClass2||'') + (this.attr.cssClass||''), {
                'p-button-active': this.attr.active,
                'btn-inactive': !!this.attr.inactive,   // IE 2026 10 13 / ODOO-5800: enabled_when — нет подходящих строк в выделении
                // p-button-secondary p-button-text0 
            }]
        },
    },
    watch: {
        initialAttr(attr) {
            // ремоунта нет, если :key совпал — подхватываем новый объект вручную
            if (attr) {
                this.content_Changed()
                this.store.prepare_actionMenu(attr)
                this.updateVisibility()
            }
        },
        // attr: {
        //     handler: 'updateVisibility',
        //     deep: true
        // },
        // 'WIDGET.record.id': {
        //     handler: 'updateVisibility',
        //     deep: true
        // },
        // 'WIDGET.record._meta': {
        //     handler: 'updateVisibility',
        //     deep: true
        // }
    },
}
</script>

<style>
/* IE 2026 10 13 / ODOO-5800: кнопка с enabled_when без подходящих строк в выделении — приглушена, подсказка (причина) показывается: атрибут disabled не ставим, иначе подсказки нет */
.commandPanel-buttons.btn-inactive { opacity: 0.45; cursor: not-allowed; }
.commandPanel-buttons {
    overflow: visible;
    white-space: nowrap;
}
/* кнопка с иконкой-глифом (pi-*) И подписью: зазор между иконкой и текстом;
   иконки без подписи (:empty) не трогаем — иначе съезжает центровка */
.commandPanel-buttons[class*=" pi-"] > span:not(:empty) {
    margin-left: 0.35rem;
}
/* IE 2026 11 02 / ODOO-349799 (strip-segmented), заказ Игоря 02.11 (два скрина: «сгруппируй опции Source / Target, как переключатель „Період“ теплокарты»):
   группа кнопок, заданная БЭКОМ (cssClass segmented-btn у каждой кнопки группы, segmented-first / segmented-last у крайних — predefined_exchange_ui.option_css),
   рисуется СОЕДИНЁННОЙ, как HeatmapSwitches .hm-seg / .hm-seg-btn / .hm-on: общая рамка, без скруглений и зазора между кнопками, крайние углы скруглены,
   активная (p-button-active от mark_options) — заливка и рамка как у нажатого сегмента «Період», а не янтарная .p-button-active. Нового attr_type нет. */
.p-button.commandPanel-buttons.segmented-btn { border-radius: 0; border: 1px solid var(--hm-line, var(--surface-border, #e1e4ec)) !important; }
.p-button.commandPanel-buttons.segmented-btn + .p-button.commandPanel-buttons.segmented-btn { margin-left: -1px; }
.p-button.commandPanel-buttons.segmented-first { border-radius: 6px 0 0 6px; }
.p-button.commandPanel-buttons.segmented-last { border-radius: 0 6px 6px 0; }
.p-button.commandPanel-buttons.segmented-first.segmented-last { border-radius: 6px; }
.p-button.commandPanel-buttons.segmented-btn:enabled:hover { background: var(--surface-hover, #f3f4f8) !important; }
.p-button.commandPanel-buttons.segmented-btn.p-button-active, .p-button.commandPanel-buttons.segmented-btn.p-button-active:enabled:hover {
    background: var(--hm-sel-bg, var(--highlight-bg, #e3e7f6)) !important; border-color: var(--primary-color, #3949ab) !important; position: relative; z-index: 1;
}
</style>
